<Loader :loading="loading" />

<div>
  <div v-if="is_uploading" class="text-center text-xxs my-3">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Uploading...</span>
    </div>
    <p>Uploading document...</p>
  </div>
  <div class="w-100 px-3 p-2 border-bottom">
    <button class="btn btn-sm btn-primary text-xxs" data-bs-toggle="modal" data-bs-target="#staticBackdrop">
      <i class="bi bi-plus-lg"></i> New Folder
    </button>
    <button class="btn btn-sm btn-secondary text-xxs ms-2" v-if="folderStack.length > 0"  @click="triggerFileUpload">
      <i class="bi bi-upload"></i> Upload Document
    </button>
    <input
      type="file"
      ref="warehouse_file"
      class="d-none"
      @change="handleFileUpload"
      accept=".pdf,.doc,.docx,.xls,.xlsx,.txt,.png,.jpg,.jpeg,.gif,.bmp"
    />
  </div>

  <div class="px-1">
    <nav class="mb-0 mt-3 p-0 px-2 text-xs">
      <ol class="breadcrumb">
        <li class="breadcrumb-item text-dark fw-bold" :class="{ active: folderStack.length === 0 }">
          <span v-if="folderStack.length === 0">DocumentWarehouse</span>
          <a v-else href="#" @click.prevent="goBack" class="text-decoration-none text-dark">DocumentWarehouse</a>
        </li>
    
        <li
          v-for="(folder, index) in folderStack"
          :key="folder.id"
          class="breadcrumb-item fw-bold"
          :class="{ active: index === folderStack.length - 1 }"
        >
          <a
            v-if="index !== folderStack.length - 1"
            href="#"
            @click.prevent="goBack()"
            class="text-decoration-none text-dark"
          >
            {{ folder.folder_name }}
          </a>
          <span v-else>{{ folder.folder_name }}</span>
        </li>
      </ol>
    </nav>
    <table v-if="currentFolders.length > 0 || currentFiles.length > 0" class="table table-light text-xs">
      <thead>
        <tr class="text-xxs">
          <th class="text-center"><i class="bi bi-file-earmark"></i></th>
          <th class="fw-bold">Name</th>
          <th>Created</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <!-- Render folders -->
        <FolderView
          v-for="folder in currentFolders"
          :key="folder.id"
          :folder="folder"
          @open-folder="handleOpenFolder"
          @folder-deleted="remove_folder(folder.id)"
        />
        <!-- Render files -->
        <tr v-for="fileItem in currentFiles" :key="'file-' + fileItem.id">
          <td class="text-center">
            <img :src="getFileIcon(fileItem.file.s3_url)" class="file-icon download-icon w-20px" />
          </td>
          <td class="text-xs text-dark">
            <div @click="previewDocument(fileItem)">

              <span class="file-name">{{ getFileName(fileItem.file.s3_url) }}</span>
              <a :href="fileItem.file.s3_url" download :title="getFileName(fileItem.file.s3_url)" class="download-btn" @click.stop>
                <img src="https://cdn-icons-png.flaticon.com/128/724/724933.png" class="download-icon w-20px" />
              </a>
            </div>
          </td>
          <td class="text-xs text-dark">
            {{ fileItem.file.date || '—' }}
          </td>
          <td class="text-xs text-dark">
            
          </td>
        </tr>
      </tbody>
    </table>
    
    <!-- Show "Folder empty" message only if both folders and files are empty -->
    <div v-else-if="currentFolders.length === 0 && currentFiles.length === 0" class="text-center mt-5">
      <img src="@/assets/images/empty-folder.png" class="w-150" alt="">
      <p>This folder is empty</p>
    </div>

    <div v-else>
      <p>No folders found</p>
    </div>
  </div>
</div>


<div class="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <label for="">Folder name</label>
        <input type="text" v-model="folder_name" placeholder="Enter folder name">
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" @click="create_folder" data-bs-dismiss="modal">Save</button>
      </div>
    </div>
  </div>
</div>